module.exports = __webpack_public_path__ + "img/debit_card_template.4b1647ea.png";